
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/billing-software",
      function () {
        return require("private-next-pages/features/billing-software.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/billing-software"])
      });
    }
  